import '../CsvJsonInfoPages.scss';


function TradePrices() {

  const data = [
    ['1', 'Sequence Number'],
    ['2', 'CAP ID Number'],
    ['3', 'Valuation Year'],
    ['4', 'Valuation Month 1 - Jan, 2 - Feb... 11 - Nov, 12 - Dec'],
    ['5', 'Valuation Mileage'],
    ['6', 'Retail Value'],
    ['7', 'Clean Value'],
    ['8', 'Average Value'],
    ['9', 'Below Average Value'],
  ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>Used Values Live - Trade Prices</h1>
            <p> Vehicle pricing table<br /><br />
                <b>File Naming Convention</b></p>
            <p>The Filename is dependent on the product being produced as follows.<br />

                CAR_yyyy-mm-dd_UsedValuesLive_Trade.txt<br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003. <br />
            </p>

            <table>
      <thead>
        <tr>
          <th>Field</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td>{row[0]}</td>
            <td>{row[1]}</td>
          </tr>
        ))}
      </tbody>
    </table>
        </div>
    );
}

export default TradePrices;
